import React, { Component } from "react";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import "./../../../View.css";
import "./../../../Grid.css";
import "./../../../Form.css";
import "./../../../App.css";
import SearchView from "../../../widgets/SearchView";
import TradeQualificationSetupSearchForm from './../TradeQualification/TradeQualificationSetupSearchForm';
import { ViewContainer } from "./../../../View.jsx";
import ViewUtils from "./../../../ViewUtils";
import withMenuPermission from "../../../widgets/withMenuPermission";


const headCells = [
    { id: 'Code', numeric: false, disablePadding: true, label: 'Code' },
    { id: 'Title', numeric: false, disablePadding: true, label: 'Title' },
    { id: 'OFOOccupation', numeric: false, disablePadding: true, label: 'OFO Occupation Code' }
];

const searchParameters = [
    { Name: "Code", Value: "" },
    { Name: "Title", Value: "" }
];

const utils = new ViewUtils();

class TradeQualificationSetupSearch extends Component {
    constructor(props) {
        super(props)

        this.state = {
            model: {
                Code: "",
                Title: ""
            },
            selectedTradeQualificationProgramme: null,
            keyUpSwitch: false
        }

        this.toolbarConfig = {
            items: [
                {
                    type: "buttonGroup",
                    buttons: [
                        { id: 'add', label: '', tooltip: 'Add', icon: 'AddIcon', visible: this.props.menuPermissionItem.Add },
                        { id: 'edit', label: '', tooltip: 'Edit', icon: 'EditIcon', disabled: true, visible: this.props.menuPermissionItem.Edit },
                        { id: "delete", label: '', tooltip: 'Remove Trade Qualification', icon: 'DeleteIcon', disabled: true, visible: this.props.menuPermissionItem.Delete }
                    ]
                }
            ]
        }
    }

    onkeyup(e) {
        //console.log(e.charCode)
        if (e.charCode == 13) {
            this.setState({ keyUpSwitch: !this.state.keyUpSwitch })
        }
    }

    render() {
        return (
            <ViewContainer title="">
                <SearchView headCells={headCells} dataUrl={!utils.isNull(this.props.dataUrl) ? this.props.dataUrl : "api/sims/TradeQualificationsetup/getsearch"}
                    entityViewPath='/TradeQualificationsetup'
                    title='Trade Qualification'
                    model={this.state.model} toolbarConfig={this.toolbarConfig}
                    searchParameters={searchParameters} onLookupValueChange={this.props.onLookupValueChange}
                    descriptionProp="Title" mode={this.props.mode}
                    keyUpSwitch={this.state.keyUpSwitch}
                    history={this.props.history}
                    multiSelect={this.props.multiSelect}
                    deleteUrl={"api/sims/TradeQualificationSetup/removeTradeQualification"} useDeletePost={true}
                    promptTitle={"Remove TradeQualification Programme"} selectionCallbackMode={this.props.selectionCallbackMode}
                    promptContent={"Removing the Trade Qualification programme is a permanent action and the TradeQualification programme will not be available going forward. Are you sure you want to remove this Trade Qualification programme?"}
                >
                    <TradeQualificationSetupSearchForm
                        data={this.state.model}
                        onKeyUp={(e) => { this.onkeyup(e) }}
                        valueChangeHandler={(values) => {
                            if (JSON.stringify(this.state.model) !== JSON.stringify(values)) {
                                this.setState({ model: values });
                            }
                        }}
                    />
                </SearchView>
            </ViewContainer>

        );
    }
}

export default withRouter(withMenuPermission(TradeQualificationSetupSearch));

